// Registers the combined PWA/FCM service worker. Registered eagerly on app
// boot regardless of the current route (see App.vue) - guest booking pages
// still stay uncontrolled because of the `scope: "/ad/"` passed to
// `register()` below, not because of when this function gets called.

let registrationPromise: Promise<ServiceWorkerRegistration | null> | null = null;

export const registerOwnerServiceWorker =
  (): Promise<ServiceWorkerRegistration | null> => {
    if (!("serviceWorker" in navigator)) {
      return Promise.resolve(null);
    }

    if (!registrationPromise) {
      registrationPromise = navigator.serviceWorker
        .register("/service-worker.js", { scope: "/ad/" })
        .catch((error) => {
          console.error("Service worker registration failed", error);
          return null;
        });
    }

    return registrationPromise;
  };
